<script>
import axios from "axios";
import config from "@/utils/config";

export default {
  props: {
    ripetizione: {
      type: Object,
      required: true,
    },
    userType: {
      type: String,
      required: true,
      validator: (value) => ['studente', 'tutor'].includes(value)
    }
  },
  data() {
    return {
      valutazione: {
        commento: '',
        valutazioneGentilezza: 0,
        valutazionePuntualita: 0,
        valutazioneCompetenzaORendimento: 0,
        votoImpegno: 0,
        valutatoreId: null,
        valutatoId: null,
        ripetizioneId: this.ripetizione ? this.ripetizione.id : null,
        gruppoId: null,
      },
      loading: false,
      classRatings: {
        valutazioneCompetenzaORendimento: 0,
        valutazioneGentilezza: 0,
        valutazionePuntualita: 0,
        votoImpegno: 0,
        valutatoreId: this.ripetizione.insegnanteId,
        valutatoId: null,
        ripetizioneId: this.ripetizione.id,
        gruppoId: null,
      },
      studentRatings: {
        valutazioneCompetenzaORendimento: '',
        valutazioneGentilezza: '',
        valutazionePuntualita: '',
        votoImpegno: '',
        commento: '',
        valutatoreId: this.ripetizione.insegnanteId,
        valutatoId: null,
        ripetizioneId: this.ripetizione,
        gruppoId: null,
      },
      showStudentEvaluationSection: false, // Track if additional section is shown
      selectAll: false, // Track select all checkbox
      students: [], // Array to store student data
      multiples: false, // Track if there are multiple students
    };
  },
  mounted() {
    if(this.userType !== 'studente')
      this.ask_for_studenti();
  },
  computed: {
    isSaveDisabled() {
      if (this.userType === 'studente') {
        return this.valutazione.valutazioneGentilezza === null ||
            this.valutazione.valutazionePuntualita === null ||
            this.valutazione.valutazioneCompetenzaORendimento === null;
      } else {
        return this.studentRatings.valutazioneCompetenzaORendimento === null ||
            this.studentRatings.valutazioneGentilezza === null ||
            this.studentRatings.valutazionePuntualita === null ||
            this.studentRatings.votoImpegno === null;
      }
    },
    isAnyStudentSelected() {
      return this.students.some(student => student.selected);
    },
  },
  watch: {
    selectAll: {
      handler(newValue) {
        this.students.forEach(student => {
          student.selected = newValue;
        });
      }
    },
  },
  created() {
    if (this.userType === 'studente') {
      this.valutazione.valutatoId = this.ripetizione.insegnante.id;
      this.valutazione.valutatoreId = this.ripetizione.allievo.id;
    }
  },
  methods: {
    updateRating(field, value) {
      this.valutazione[field] = value;
    },
    formatDate(dataOra) {
      const date = new Date(dataOra);
      const giorniSettimana = ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];

      const giornoSettimana = giorniSettimana[date.getDay()];
      const giorno = date.getDate().toString().padStart(2, '0');
      const mese = (date.getMonth() + 1).toString().padStart(2, '0');
      const anno = date.getFullYear();

      const ore = date.getHours().toString().padStart(2, '0');
      const minuti = date.getMinutes().toString().padStart(2, '0');

      return `${giornoSettimana} ${giorno}/${mese}/${anno} alle ${ore}:${minuti}`;
    },
    async saveValutazione() {
      this.loading = true;
      try {
        await axios.post(config.baseUrl + '/valutazione/save', this.valutazione);
        this.$emit('chiudi');
      } catch (error) {
        console.error("Errore nel salvataggio della valutazione", error);
      } finally {
        this.loading = false;
      }
    },
    setStudentRating(category, rating) {
      this.studentRatings[category] = rating;
    },
    async saveStudentEvaluation() {
      this.loading = true;
      try {
        // Create a new object with the student evaluation data
        const studentEvaluation = {
          valutazioneCompetenzaORendimento: this.studentRatings.valutazioneCompetenzaORendimento,
          valutazioneGentilezza: this.studentRatings.valutazioneGentilezza,
          valutazionePuntualita: this.studentRatings.valutazionePuntualita,
          votoImpegno: this.studentRatings.votoImpegno,
          commento: this.studentRatings.commento,
          valutatoreId: this.ripetizione.insegnante.id,
          valutatoId: this.ripetizione.allievo.id,
          ripetizioneId: this.ripetizione.id,
          gruppoId: this.ripetizione.gruppoId
        };

        await axios.post(config.baseUrl + '/valutazione/save', studentEvaluation);
        this.$emit('chiudi');
      } catch (error) {
        console.error("Errore nel salvataggio della valutazione", error);
      } finally {
        this.loading = false;
      }
    },
    async ask_for_studenti() {
      this.classRatings.valutatoreId = this.ripetizione.insegnante.id;
      this.classRatings.gruppoId = this.ripetizione.gruppoId;
      console.log("Ripetizione:", this.ripetizione.gruppoId);
      if (this.ripetizione && this.ripetizione.gruppoId !== '' && this.ripetizione.gruppoId !== null && this.ripetizione.gruppoId !== undefined) {    
        this.classRatings.valutatoId = this.ripetizione.allievo.id;
        const url = config.baseUrl + '/gruppo/studenti/gruppo_id/' + this.classRatings.gruppoId;
        await axios.get(url).then((response) => {
          this.students = response.data;
          this.students.selected = false;
          this.multiples = this.students.length > 1;
        }).catch((error) => {
          console.error("Errore nel recupero degli studenti", error);
        });
      }
    }
  },

// Vecchio codice per la valutazione dei gruppi, TODO ripristinare e testare
  setClassRating(category, rating) {
      this.classRatings[category] = rating;
    },
    setStudentRating(category, rating) {
      this.studentRatings[category] = rating;
    },
    async addStudentEvaluation() {
      this.showStudentEvaluationSection = true; // Show the additional section
      this.students.forEach(student => {
        student.valutazioneCompetenzaORendimento = this.classRatings.valutazioneCompetenzaORendimento;
        student.valutazioneGentilezza = this.classRatings.valutazioneGentilezza;
        student.valutazionePuntualita = this.classRatings.valutazionePuntualita;
        student.votoImpegno = this.classRatings.votoImpegno;
        student.ripetizioneId = this.ripetizione.id;
        student.valutatoId = student.id;
        student.gruppoId = this.ripetizione.gruppoId;
        student.valutatoreId = this.classRatings.valutatoreId;
      });
    },
    //finished evaluation
    async finishEvaluation() {
      if (this.classRatings.valutazioneCompetenzaORendimento === '' || this.classRatings.valutazioneGentilezza === '' || this.classRatings.valutazionePuntualita === '' || this.classRatings.votoImpegno === '')
        alert('Please valuate the students before finishing the evaluation');

      if (!this.showStudentEvaluationSection) {
        this.students.forEach(student => {
          student.valutazioneCompetenzaORendimento = this.classRatings.valutazioneCompetenzaORendimento;
          student.valutazioneGentilezza = this.classRatings.valutazioneGentilezza;
          student.valutazionePuntualita = this.classRatings.valutazionePuntualita;
          student.votoImpegno = this.classRatings.votoImpegno;
          student.ripetizioneId = this.ripetizione.id;
          student.valutatoId = student.id;
          student.gruppoId = this.ripetizione.gruppoId;
          student.valutatoreId = this.classRatings.valutatoreId;
        });
      }
      await this.finishEvaluationTable();

      // Reset classRatings fields
      this.classRatings.valutazioneCompetenzaORendimento = '';
      this.classRatings.valutazioneGentilezza = '';
      this.classRatings.valutazionePuntualita = '';
      this.classRatings.votoImpegno = '';

      this.$emit('completed');
    },
    toggleSelectAll(event) {
      this.selectAll = event.target.checked;
    },
    async finishEvaluationTable() {
      if (!this.isAnyStudentSelected) {
        try {
          await axios.post(config.baseUrl + '/valutazione/tutor_ripetizione', this.students);
          this.$emit('chiudi');
        } catch (error) {
          console.error("Errore nel salvataggio della valutazione", error);
        } finally {
          this.loading = false;
        }

        const page = document.querySelector('.valutation-container');
        page.style.display = 'none';
      } else if (this.studentRatings.valutazioneCompetenzaORendimento === '' || this.studentRatings.valutazioneGentilezza === '' || this.studentRatings.valutazionePuntualita === '' || this.studentRatings.votoImpegno === '') {
        alert('Please valuate the selected before finishing the evaluation');
      }
      this.$emit('completed');
    },
    save() {
      this.students.forEach(student => {
        student.highlight = false;
      });


      if(this.studentRatings.valutazioneCompetenzaORendimento === '' || this.studentRatings.valutazioneGentilezza === '' || this.studentRatings.valutazionePuntualita === '' || this.studentRatings.votoImpegno === '') {
        alert('Please valuate the selected before saving the evaluation');
        return;
      }else{
        this.students.forEach((student) => {
          if (student.selected) {
            student.valutazioneCompetenzaORendimento = this.studentRatings.valutazioneCompetenzaORendimento;
            student.valutazioneGentilezza = this.studentRatings.valutazioneGentilezza;
            student.valutazionePuntualita = this.studentRatings.valutazionePuntualita;
            student.votoImpegno = this.studentRatings.votoImpegno;
            student.valutatoId = student.id;
            student.gruppoId = this.ripetizione.gruppoId;
            student.valutatoreId = this.ripetizione.insegnanteId;
            student.ripetizioneId = this.ripetizione.id;
            student.selected = false;
            student.highlight = true;
            student.different = true;
          }
        });
      }

      if(this.selectAll){
        this.selectAll = false;
      }

      this.studentRatings.valutazioneCompetenzaORendimento = '';
      this.studentRatings.valutazioneGentilezza = '';
      this.studentRatings.valutazionePuntualita = '';
      this.studentRatings.votoImpegno = '';
    },
  }
</script>


<template>
  <!-- Sezione 1: Studente valuta il tutor -->
  <div class="student-evaluate-tutor" v-if="userType === 'studente'">
    <h4>Valuta il tutor</h4>
    <p>Nome: <strong> {{ripetizione.insegnante.cognome}} {{ripetizione.insegnante.nome}} </strong></p>
    <p>Materia: <strong>{{ ripetizione.materia.nome }} </strong></p>
    <p id="marginfor">Data: <strong> {{ formatDate(ripetizione.dataOra) }} </strong></p>
      <div class="tutor-valuation">
          <hr><label for="valutazioneGentilezza" style="font-weight: 600">Gentilezza</label>
            <div class="rating-labels">
              <span class="label-left">Scarso</span>
              <span class="label-right">Eccellente</span>
            </div>
            <div class="rating">
              <span
                  v-for="value in 5"
                  :key="`rating-valutazioneGentilezza-${value}`"
                  class="star"
                  :class="{ selected: valutazione.valutazioneGentilezza >= value }"
                  @click="updateRating('valutazioneGentilezza', value)"
              >★</span>
            </div>
          <hr><label for="valutazionePuntualita" style="font-weight: 600">Puntualità</label>
            <div class="rating-labels">
              <span class="label-left">Scarso</span>
              <span class="label-right">Eccellente</span>
            </div>
            <div class="rating">
              <span
                  v-for="value in 5"
                  :key="`rating-valutazionePuntualita-${value}`"
                  class="star"
                  :class="{ selected: valutazione.valutazionePuntualita >= value }"
                  @click="updateRating('valutazionePuntualita', value)"
              >★</span>
            </div>
          <hr><label for="valutazioneCompetenzaORendimento" style="font-weight: 600">Competenza</label>
            <div class="rating-labels">
              <span class="label-left">Scarso</span>
              <span class="label-right">Eccellente</span>
            </div>
            <div class="rating">
              <span
                  v-for="value in 5"
                  :key="`rating-valutazioneCompetenzaORendimento-${value}`"
                  class="star"
                  :class="{ selected: valutazione.valutazioneCompetenzaORendimento >= value }"
                  @click="updateRating('valutazioneCompetenzaORendimento', value)"
              >★</span>
            </div>
          <hr><label for="votoImpegno" style="font-weight: 600">Impegno</label>
            <div class="rating-labels">
              <span class="label-left">Scarso</span>
              <span class="label-right">Eccellente</span>
            </div>
            <div class="rating">
              <span
                  v-for="value in 5"
                  :key="`rating-votoImpegno-${value}`"
                  class="star"
                  :class="{ selected: valutazione.votoImpegno >= value }"
                  @click="updateRating('votoImpegno', value)"
              >★</span>
            </div>

      <hr><h6>Commento (facoltativo)</h6>
      <textarea v-model="valutazione.commento" class="commento-textarea" placeholder="Scrivi qui il tuo commento..."></textarea>
      </div>

    <div>
      <div class="modal-buttons">
        <div v-if="loading" class="spinner-border">
        </div>
        <div class="modal-btn cancel-btn" @click="$emit('chiudi')">Annulla</div>
        <div class="modal-btn save-btn" @click="isSaveDisabled ? null : saveValutazione()" :class="{ 'disabled': isSaveDisabled }">Salva</div>
      </div>
    </div>
  </div>

  <!-- Sezione 3: Valuta studente (sostituisce Valuta la classe) -->
  <div v-else>
    <div class="valutation-container">
      <div class="valutation-box">
        <h2>Valuta studente</h2>
        <p>Nome: <strong>{{ ripetizione.allievo.cognome }} {{ ripetizione.allievo.nome }}</strong></p>
        <p>Materia: <strong>{{ ripetizione.materia.nome }}</strong></p>
        <p id="marginfor">Data: <strong>{{ formatDate(ripetizione.dataOra) }}</strong></p>

        <div class="student-evaluation">
          <hr><label for="valutazioneCompetenzaORendimento" style="font-weight: 600">Rendimento</label>
          <div class="rating-labels">
            <span class="label-left">Scarso</span>
            <span class="label-right">Eccellente</span>
          </div>
          <div class="rating">
            <span
                v-for="star in 5"
                :key="'performance-star-' + star"
                class="star"
                :class="{ selected: star <= studentRatings.valutazioneCompetenzaORendimento }"
                @click="setStudentRating('valutazioneCompetenzaORendimento', star)"
            >★</span>
          </div>

          <hr><label for="valutazioneGentilezza" style="font-weight: 600">Gentilezza</label>
          <div class="rating-labels">
            <span class="label-left">Scarso</span>
            <span class="label-right">Eccellente</span>
          </div>
          <div class="rating">
            <span
                v-for="star in 5"
                :key="'kindness-star-' + star"
                class="star"
                :class="{ selected: star <= studentRatings.valutazioneGentilezza }"
                @click="setStudentRating('valutazioneGentilezza', star)"
            >★</span>
          </div>

          <hr><label for="valutazionePuntualita" style="font-weight: 600">Puntualità</label>
          <div class="rating-labels">
            <span class="label-left">Scarso</span>
            <span class="label-right">Eccellente</span>
          </div>
          <div class="rating">
            <span
                v-for="star in 5"
                :key="'punctuality-star-' + star"
                class="star"
                :class="{ selected: star <= studentRatings.valutazionePuntualita }"
                @click="setStudentRating('valutazionePuntualita', star)"
            >★</span>
          </div>

          <hr><label for="votoImpegno" style="font-weight: 600">Impegno</label>
          <div class="rating-labels">
            <span class="label-left">Scarso</span>
            <span class="label-right">Eccellente</span>
          </div>
          <div class="rating">
            <span
                v-for="star in 5"
                :key="'commitment-star-' + star"
                class="star"
                :class="{ selected: star <= studentRatings.votoImpegno }"
                @click="setStudentRating('votoImpegno', star)"
            >★</span>
          </div>

          <hr><h6>Commento (facoltativo)</h6>
          <textarea v-model="studentRatings.commento" class="commento-textarea" placeholder="Scrivi qui il tuo commento..."></textarea>
        </div>

        <div class="modal-buttons">
          <div v-if="loading" class="spinner-border">
          </div>
          <div class="modal-btn cancel-btn" @click="$emit('chiudi')">Annulla</div>
          <div class="modal-btn save-btn" @click="isSaveDisabled ? null : saveStudentEvaluation()" :class="{ 'disabled': isSaveDisabled }">Salva</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
div{
  color:black;
}

#marginfor {
  margin-bottom: 15px;
}

p {
  margin-bottom: 1px;
}

.modal-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
  gap: 10px;
}

.modal-btn {
  padding: 6px 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  text-align: center;
  display: inline-block;
  transition: opacity 0.3s ease;
  border: 1px solid transparent;
}

.save-btn {
  background-color: #007bff;
  color: white;
  border: 1px solid #007bff;
}

.cancel-btn {
  background-color: #f1f1f1;
  color: #333;
  border: 1px solid #ccc;
}

.modal-btn:hover {
  opacity: 0.9;
  border-color: #999;
}

.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.commento-textarea {
  width: 100%;
  height: 75px;
  padding: 10px;
  border: 2px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  color: #333;
  background-color: white;
  resize: none;
  transition: border-color 0.3s;
  caret-color: gray;
}

.commento-textarea:focus {
  border-color: #007bff;
  outline: none;
}

.valutation-container {
  display: flex;
  justify-content: center; /* Centers the child elements horizontally */
  align-items: center; /* Centers the child elements vertically */
  width: 100%;
  caret-color: transparent;
}

.valutation-box {
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  background-color: #f9f9f9;
  text-align: left;
  width: 600px; /* Fixed width for the evaluation box */
  max-width: 90%; /* Responsive design consideration */
}

.valutation-box h2 {
  text-align: center;
  color: #333;
  margin-bottom: 20px;
}

.star {
  font-size: 25px;
  color: #ccc;
  cursor: pointer;
}

.tutor-valuation .star.selected,
.star.selected {
  color: #f5c518;
}

.student-evaluation .rating {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.rating-labels {
  display: flex; /* Use flexbox for alignment */
  justify-content: space-between; /* Push the labels to opposite ends */
  width: 100%; /* Ensure it spans the full width of the container */
  font-size: 14px; /* Adjust font size for better readability */
  font-weight: 500; /* Slightly bold for emphasis */
  color: #555; /* Neutral gray for text color */
  margin-top: 10px; /* Add spacing above */
}

.label-left {
  text-align: left; /* Align the "Scarso" label to the left */
}

.label-right {
  text-align: right; /* Align the "Eccellente" label to the right */
}

.tutor-valuation .rating {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.tutor-valuation .star {
  cursor: pointer;
  font-size: 2rem; /* Adjust the size as needed */
  color: #ccc; /* Default color */
}

.student-evaluate-tutor {
  background: white;
  padding: 20px;
  border-radius: 10px;
  caret-color: transparent;
}
</style>